
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M12.666 22a9.324 9.324 0 0115.666-6.845.665.665 0 00.453.178h2.548a.666.666 0 00.459-1.152L17.373.546a2 2 0 00-2.747 0L.209 14.181a.666.666 0 00.459 1.152h2.666c.368 0 .667.299.667.667v13.333c0 .736.597 1.334 1.333 1.334H17.2a.313.313 0 00.156-.584A9.336 9.336 0 0112.666 22zm18.846 7.154l-2.934-2.933a.667.667 0 01-.116-.787A7.271 7.271 0 0029.333 22 7.333 7.333 0 0022 14.666 7.333 7.333 0 0014.666 22 7.333 7.333 0 0022 29.333a7.255 7.255 0 003.44-.868.667.667 0 01.787.117l2.933 2.934a1.668 1.668 0 002.357-2.356l-.005-.006zM17.333 22a4.667 4.667 0 119.333 0 4.667 4.667 0 01-9.333 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    